import * as React from "react"
import { Image } from "react-native";
import type { ImageStyle } from "react-native"

const iconStyle = (size:string, marginLeft:number=0, marginRight:number=0, marginTop:number=0,marginBottom:number=0): ImageStyle => {
    return{
        flex:1,
        width: size=='medium' ? 25 : size=='small' ? 20 : size == 'tiny' ? 15 : 30,
        height: size=='medium' ? 25 : size=='small' ? 20 : size == 'tiny' ? 15 : 30,
        marginBottom:marginBottom,
        marginRight:marginRight,
        marginLeft:marginLeft,
        marginTop:marginTop,
        resizeMode: "contain"
    }
}

const iconStyleNoFlex = (size:string, marginLeft:number=0, marginRight:number=0, marginTop:number=0,marginBottom:number=0): ImageStyle => {
    return{        
        width: size=='medium' ? 25 : size=='small' ? 20 : size == 'tiny' ? 15 : 30,
        height: size=='medium' ? 25 : size=='small' ? 20 : size == 'tiny' ? 15 : 30,
        marginBottom:marginBottom,
        marginRight:marginRight,
        marginLeft:marginLeft,
        marginTop:marginTop,
        resizeMode: "contain"
    }
}

export interface KiaIconProps{
    src: string,
    size?: 'tiny' | 'small' | 'medium' | 'large',
    marginLeft?: number,
    marginRight?: number,
    marginTop?: number,
    marginBottom?: number,
    noFlex?: boolean|false
}

export function KiaIcon(props: KiaIconProps){
    const style = props.noFlex ? iconStyleNoFlex : iconStyle;
    return(
        <Image
        style={style(props.size || 'large', props.marginLeft, props.marginRight, props.marginTop, props.marginBottom)}        
        source={{
            uri: props.src
        }}
        />
    )
}